import React from 'react';
import BookingRow from './BookingRow';

export default function BookingList({
  title,
  items,
  muted = false,
  cancelled = false,
  editingId = '',
  editForm = null,
  rowBusy = '',
  onStartEdit,
  onEditFormChange,
  onSaveEdit,
  onCancelEdit,
  onCancelBooking,
}) {
  if (!items.length) return null;

  return (
    <section>
      <h2 className="text-xs font-semibold uppercase text-[#6B6B6B] mb-2">{title}</h2>
      <div className="border border-[#E3E2E0] rounded-xl overflow-hidden bg-white">
        {items.map((item) => (
          <BookingRow
            key={item.id}
            item={item}
            muted={muted}
            cancelled={cancelled}
            isEditing={editingId === item.id}
            editForm={editForm}
            rowBusy={rowBusy}
            onStartEdit={onStartEdit}
            onEditFormChange={onEditFormChange}
            onSaveEdit={onSaveEdit}
            onCancelEdit={onCancelEdit}
            onCancelBooking={onCancelBooking}
          />
        ))}
      </div>
    </section>
  );
}
